import { render, staticRenderFns } from "./amountTipDialog.vue?vue&type=template&id=57fcefbb&scoped=true"
import script from "./amountTipDialog.vue?vue&type=script&lang=js"
export * from "./amountTipDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57fcefbb",
  null
  
)

export default component.exports